export default {"src":"/_next/static/media/Yes.96fa6203.svg","height":20,"width":26};